import { Skeleton, SkeletonProps, Stack } from '@mui/material';
import { addIndex, map, range } from 'ramda';

const skeletonProps = {
  variant: 'rectangular',
  height: 24,
} as SkeletonProps;

interface DocumentListSkeletonProps {
  itemCount?: number;
}
export const DocumentListSkeleton = ({ itemCount = 3 }: DocumentListSkeletonProps) => (
  <Stack
    spacing={2}
    sx={{
      paddingX: '1rem',
    }}
  >
    {addIndex(map)(
      (_: any, index: number) => (
        <Stack
          key={index}
          direction="row"
          spacing={2}
          sx={{
            flex: 1,
            alignItems: 'center',
          }}
        >
          <Skeleton {...skeletonProps} width={24} />
          <Skeleton {...skeletonProps} width={'100%'} />
        </Stack>
      ),
      range(0, itemCount),
    )}
  </Stack>
);
